import { ArrowLeft, ArrowRight, Close } from "@mui/icons-material";
import { Avatar, Box, Drawer, IconButton, List, ListItem, ListItemAvatar, Typography } from '@mui/material';
import React, { useState } from 'react';
import { getClickableItem, getIcon } from "./DetailPanelUtils";

const MAX_PER_PAGE = 1000;
export const SidePanelUsageList = ({ usages, handleClickField, open, setOpen, t }) => {
    const [page, setPage] = useState(0);
    const totalUsages = usages?.length || 0;
    const pageStart = page * MAX_PER_PAGE;
    const maxPageEnd = (page + 1) * MAX_PER_PAGE;
    const pageEnd = Math.min(totalUsages, maxPageEnd);
    return (
        <Drawer open={open} anchor='right' onClose={() => setOpen(false)} sx={{ zIndex: 1325 }}>
          <Box overflow='hidden'>
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.dark,
                color: 'white',
                display: 'flex',
                height: '50px',
                justifyContent: 'flex-start',
                padding: '0 10px',
                width: '100%'
              }}
            >
              <Typography
                sx={{
                  flexGrow: 1,
                  textAlign: 'center'
                }}
                variant='h5'
              >
                {t('table.default.detailpane.usageTitle')}
              </Typography>
              <IconButton onClick={() => setOpen(false)} sx={{ color: 'white' }}>
                <Close />
              </IconButton>
            </Box>
            <Box height='calc(100% - 50px)' overflow='auto'>
              <List dense>
                {usages.slice(pageStart, maxPageEnd).map((usage) => {
                  const openIn = !usage.object_type?.startsWith('ct_');
                  return (
                    <ListItem key={usage.artifact_id} sx={{ paddingTop: 0 }}>
                      <ListItemAvatar sx={{ minWidth: 34, paddingRight: '8px' }}>
                        <Avatar sx={{ width: 34, height: 34, bgcolor: '#1976d2' }}>
                          {getIcon(usage.object_type)}
                        </Avatar>
                      </ListItemAvatar>
                      {getClickableItem(usage.artifact_id, null, usage.artifact_name, handleClickField, openIn,
                        t(`table.default.detailpane.tooltips.${openIn ? 'open' : 'copy'}`))}
                    </ListItem>
                  )
                })}
              </List>
                <Box display='flex' justifyContent='center' alignItems='center'>
                    <IconButton disabled={page === 0} onClick={() => setPage(page - 1)}>
                        <ArrowLeft />
                    </IconButton>
                    <Typography>{` ${pageStart + 1} - ${pageEnd} `}</Typography>
                    <IconButton disabled={maxPageEnd >= totalUsages} onClick={() => setPage(page + 1)}>
                        <ArrowRight />
                    </IconButton>
                </Box>
            </Box>
          </Box>
        </Drawer>
    )
}